export const globalStore = {};
